<template>
  <div class="page">
    <div class="title-row">
      <span class="page-title">考勤记录</span>
    </div>
    <div class="main-card">
      <!-- 筛选栏 -->
      <div class="filter-bar">
        <el-input v-model="query.name" placeholder="搜索姓名" clearable size="small" style="width:180px"></el-input>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="small"
          style="width:260px;margin-left:8px"
          @change="onDateRangeChange">
        </el-date-picker>
        <el-button type="primary" size="small" @click="fetchData" style="margin-left:8px">
          <i class="el-icon-search"></i> 查询
        </el-button>
        <el-button size="small" @click="resetQuery" style="margin-left:6px">
          <i class="el-icon-refresh"></i> 重置
        </el-button>
        <el-button size="small" @click="exportData" style="margin-left:6px">
          <i class="el-icon-download"></i> 导出
        </el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" v-loading="loading" :border="false" style="width:100%">
        <el-table-column label="姓名" prop="staffName"></el-table-column>
        <el-table-column label="上班打卡" prop="attendanceTime"></el-table-column>
        <el-table-column label="下班打卡" prop="closingTime"></el-table-column>
        <el-table-column label="日期">
          <template slot-scope="{ row }">{{ row.theDate ? row.theDate.substring(0, 10) : '' }}</template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          :current-page="query.pageNum"
          :page-size="query.pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="onPageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAttendanceList, exportAttendance } from './scheduleApi'

export default {
  name: 'AttendanceRecord',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { name: '', startDate: '', endDate: '', pageNum: 1, pageSize: 20 }
    }
  },
  mounted() { this.fetchData() },
  methods: {
    onDateRangeChange(val) {
      this.query.startDate = val ? val[0] : ''
      this.query.endDate = val ? val[1] : ''
    },
    fetchData() {
      this.loading = true
      getAttendanceList({ ...this.query }).then(res => {
        if (res && res.code == 200) {
          const data = res.result || res
          this.tableData = data.list || data.records || []
          this.total = data.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetQuery() {
      this.query.name = ''; this.query.startDate = ''; this.query.endDate = ''
      this.dateRange = []; this.query.pageNum = 1; this.fetchData()
    },
    onPageChange(page) { this.query.pageNum = page; this.fetchData() },
    async exportData() {
      try {
        const res = await exportAttendance({ ...this.query })
        if (res) {
          const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a'); a.href = url; a.download = '考勤记录.xls'; a.click()
          URL.revokeObjectURL(url)
        }
      } catch (e) { this.$message.error('导出失败') }
    }
  }
}
</script>

<style scoped>
.page { padding: 0 16px; height: calc(100vh - 56px); display: flex; flex-direction: column; overflow: hidden; }
.title-row { display: flex; align-items: center; flex-shrink: 0; padding: 8px 0 4px; }
.page-title { font-size: 18px; font-weight: 700; color: #1E293B; }
.main-card { flex: 1; min-height: 0; background: #fff; border-radius: 10px; border: 1px solid #E2E8F0; box-shadow: 0 1px 6px rgba(0,0,0,0.04); display: flex; flex-direction: column; overflow: hidden; }
.filter-bar { display: flex; align-items: center; flex-wrap: wrap; padding: 12px 16px; border-bottom: 1px solid #F1F5F9; flex-shrink: 0; }
.pagination-wrap { display: flex; justify-content: flex-end; padding: 12px 16px; border-top: 1px solid #F1F5F9; flex-shrink: 0; }
</style>
